module.exports = __webpack_public_path__ + "static/media/logo.5f11c193.png";